var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUnlockWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unlock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.0833 17.4167V11.0833C11.0814 9.12008 11.8089 7.22612 13.1248 5.76914C14.4407 4.31216 16.2511 3.39609 18.2044 3.19879C20.1577 3.00149 22.1147 3.53701 23.6953 4.70141C25.276 5.86581 26.3677 7.57601 26.7583 9.5M7.91667 17.4167H30.0833C31.8322 17.4167 33.25 18.8344 33.25 20.5833V31.6667C33.25 33.4156 31.8322 34.8333 30.0833 34.8333H7.91667C6.16776 34.8333 4.75 33.4156 4.75 31.6667V20.5833C4.75 18.8344 6.16776 17.4167 7.91667 17.4167Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlockWhite);
export default __webpack_public_path__ + "static/media/icon_unlock_white.b03fedfb2ff77666e3b008f3c854c3e4.svg";
export { ForwardRef as ReactComponent };